import { StoryBible, ProjectMetadata, FullProjectState } from '../types';

const FREE_TIERS = new Set(['free', 'free_preview']);

export function isProjectUnlocked(projectOrBible: StoryBible | ProjectMetadata | FullProjectState | any): boolean {
  if (!projectOrBible) return false;

  const bible = projectOrBible.storyBible || projectOrBible;
  const project = projectOrBible;

  // Verify across both potential locations
  // Default to 'free_preview' so a missing tier is never treated as paid
  const tier = bible.creditTier || project.creditTier || 'free_preview';
  const unlocked = bible.exportUnlocked === true || project.exportUnlocked === true;
  const hasPaidId = !!bible.paidEntitlementId || !!project.paidEntitlementId;

  // A project is unlocked only when it has a paid tier AND is explicitly marked exportUnlocked with a paidEntitlementId
  return !FREE_TIERS.has(tier) && unlocked && hasPaidId;
}
